module.exports = __webpack_public_path__ + "static/img/no-list-data.f333a80c.png";